import { render, staticRenderFns } from "./HowToVip.vue?vue&type=template&id=0a0db05b&scoped=true&"
import script from "./HowToVip.vue?vue&type=script&lang=ts&"
export * from "./HowToVip.vue?vue&type=script&lang=ts&"
import style0 from "./HowToVip.vue?vue&type=style&index=0&id=0a0db05b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0db05b",
  null
  
)

export default component.exports